<script setup>
import {computed, defineProps} from "vue";
import CloseModalButton from "./CloseModalButton.vue";

const {flowState} = defineProps(['flowState']);

const title = computed(() => {
  if (flowState.isComplete()) {
    return 'Free consultation requested!';
  }
  return 'Step ' + (flowState.step() + 1) + ' of 3';
});

const closeModal = () => {
	flowState.stopCountdown();
	flowState.close();
};

</script>

<template>
	<div class="modal-header">
		<h5 class="modal-title">{{ title }}</h5>
		<CloseModalButton css-class="btn-close" @click="() => { closeModal() }"/>
	</div>
</template>